import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconBranchSvg }  from '../../assets/icons/icon_branch_blue.svg';

const BranchIcon=(props)=>{
    return <Icon component={() => <IconBranchSvg />} {...props}/>
}

export default BranchIcon;